import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/App/Layout";
import PageBanner from "../../RaymonComponents/Commn/PageBanner";
import Footer from "../../RaymonComponents/Footer2";
import NavbarTwo from "../../RaymonComponents/Navbar";
import NewNews from "../../RaymonComponents/news/NewsBolg";
const News = () => {
  return (
    <>
      <Helmet>
        {/* <link
          rel="stylesheet"
          href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
          integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
          crossorigin="anonymous"
        /> */}
        <link rel="stylesheet" href="../../assets/fontawesome/css/all.css" />
      </Helmet>
      <Layout>
        <NavbarTwo />
        <PageBanner
          pageTitle="رایساگرام"
          homePageText="رایساگرام"
          homePageUrl="/"
          activePageText="خانه"
        />
        <NewNews />
        <Footer />
      </Layout>
    </>
  );
};
export default News;
